import { createTheme } from "@mui/material/styles";

const toastOptions = {
  style: {
    padding: 0,
    background: "white",
  },
};
const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(54, 43, 115, 1)",
    },
    secondary: {
      main: "rgba(226, 19, 110, 1)",
    },
    error: {
      main: "rgba(207, 40, 41, 1)",
    },
    text: {
      primary: "rgba(54, 43, 115, 1)", //primary text color
    },
  },
});

export { theme, toastOptions };
